import { render } from "./BookRoom.vue?vue&type=template&id=e1a49c5a&scoped=true"
import script from "./BookRoom.vue?vue&type=script&lang=js"
export * from "./BookRoom.vue?vue&type=script&lang=js"

import "./BookRoom.vue?vue&type=style&index=0&id=e1a49c5a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e1a49c5a"

export default script